export const toNormalRepresentation = (number, decimals = 5) => {
    if (typeof number !== 'number') {
        throw new Error('Input must be a number');
    }
    // Convert the number to a string in fixed-point notation
    return number.toFixed(decimals).replace(/0+$/, '').replace(/\.$/, '');
};
